import { Layout, Spin } from 'antd';
import { memo, useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import HeaderLayout from '../components/HeaderLayout';
import SiderLayout from '../components/SiderLayout';
import { AuthContext } from '../contexts/AuthContext';

const LayoutPage = () => {
  const {
    authState: { authLoading, isAuthenticated },
  } = useContext(AuthContext);

  if (authLoading) {
    return (
      <div
        style={{
          left: '50%',
          top: '50%',
          transform: 'translateY(-50%)',
          position: 'absolute',
        }}
      >
        <Spin size="large" />
      </div>
    );
  } else if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <Layout hasSider>
      <SiderLayout />
      <Layout
        className="site-layout"
        style={{
          marginLeft: 325,
        }}
      >
        <HeaderLayout />
        <Outlet />
      </Layout>
    </Layout>
  );
};

export default memo(LayoutPage);
